import axios from "axios";
import { SERVER_URL } from "Constants";
import { EntityControllerData } from "./shared";
import { SearchEntityDetailAu } from "Views/Components/JurisdictionBusinessEntitySearchBox/AustralianEntitySearchBox";
import { DataTypeSource } from "Models/Enums";
import { AxiosConfigFactory } from "Util/AxiosUtil";

export type BusinessNumberDescriptionAu = {
	mapAbnEntityCodeToDescription: Record<string, string>;
	mapAcnEntityCodeToDescription: Record<string, string>;
	mapAcnEntityStatusToDescription: Record<string, string>;
};

export async function fetchBusinessNumberDescription() {
	const url = `${SERVER_URL}/api/BusinessNumber/au/descriptions`;
	return await axios.get<BusinessNumberDescriptionAu>(url);
}

export type ValidatedBusinessDetailsResponse = {
	abnDetails?: AbnBusinessEntityDetail
	acnDetails?: AcnBusinessEntityDetail
	// If the response is valid
	valid: boolean;
	// Error message from backend if there is not a valid response
	errorMessage?: string;
}

// Future - refactor this and the api/businessnumber/au apis to use BusinessDetailEntity.tsx
export type BusinessEntityDetail = {
	// Entity Identifier Number
	identifierNumber?: string
	// Entity Status Code
	statusCode?: string;
	// Entity Type Code
	typeCode?: string;
	// Entity Name
	name?: string;
	// Effective business (trading) name from the ABR
	tradingName?: string;
	source?: DataSourceDetails
}

export type AcnBusinessEntityDetail = BusinessEntityDetail;

export type AbnBusinessEntityDetail = BusinessEntityDetail & {

	// Registered sole trader information
	firstName?: string;
	lastName?: string;
	otherGivenName?: string;
}

export type DataSourceDetails = {
	timeStamp?: Date
	type: DataTypeSource,
}


export const AbnTypeCode = {
	// Sole trader / individual
	Individual: "IND"
}

export function verifyBusinessNumber(abn?: string | null, acn?: string | null, skipAcnFormatValidation?: boolean): Promise<ValidatedBusinessDetailsResponse> {

	return axios.post(`${SERVER_URL}/api/BusinessNumber/au/find`, {
		abn: abn,
		acn: acn,
		skipAcnFormatValidation: skipAcnFormatValidation ?? false,
	}).then(data => {
		return data.data;
	}).catch(exception => {
		return {
			valid: false,
			errorMessage: "An error occurred while verifying the business number."
		}
	});
}

export type NzBusinessQueryOption = {
	searchTerm: string,
	pageNo: number,
	pageSize: number
}

export type SearchEntityDetailNz = {
	nzbn: string;
	ncn: string;
	name: string;
	tradingName?: string;
	status: string;
	address: string;
}

export type NzBusinessSearchResponse = EntityControllerData<SearchEntityDetailNz> & {
	errorMessage?: string;
}

export async function fetchNzBusinessSearch(queryOption: NzBusinessQueryOption) {
	const url = `${SERVER_URL}/api/BusinessNumber/nz/search`;
	const params = AxiosConfigFactory.createRequestConfig(queryOption);
	return await axios.get<NzBusinessSearchResponse>(url, params);
}

export type AuBusinessQueryOptionLookupMethod =  "ABN" | "ACN" | "name";
export type AuBusinessQueryOption = {
	searchTerm: string,
	lookupMethod: AuBusinessQueryOptionLookupMethod,
	pageNo: number,
	pageSize: number
}


export type AuBusinessSearchResponse = EntityControllerData<SearchEntityDetailAu> & {
	errorMessage?: string;
}

export async function fetchAuBusinessSearch(queryOption: AuBusinessQueryOption) {
	const url = `${SERVER_URL}/api/BusinessNumber/au/search`;
	const params = AxiosConfigFactory.createRequestConfig(queryOption);
	return await axios.get<AuBusinessSearchResponse>(url, params);
}

